export const aclCategory = [
    { 'id': 'AUTHOR', 'label': 'Autor' },
    { 'id': 'ASSIGNEE', 'label': 'Zpracovatelé' },
    { 'id': 'RESOURCES', 'label': 'Všechny zdroje' },
    { 'id': 'ANYONE', 'label': 'Kdokoliv' },
]

export default { aclCategory }
